import React from 'react';
import { useTranslation } from 'react-i18next';

import withRouter from '../../hooks/with-router';
import PageContainer from '../../components/layout/page-container/PageContainer';
import AppEntityAvatar, {
  AvatarSize,
} from '../../components/designe/app-entity-avatar/AppEntityAvatar';
import { AvatarTypes } from '../../components/designe/app-avatar/AppAvatar';
import UsersList from '../../components/reusable/users-list/UsersList';
import { Box, Grid, Typography } from '@mui/material';

import Posts from '../../components/reusable/posts/Posts';
import AppButton from '../../components/designe/app-button/AppButton';
import theme from '../../styles/theme';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { Paths } from '../../shared/paths';
import CommunitiesList, {
  CommunityViewType,
} from '../../components/reusable/communities-list/CommunitiesList';
import { useStyles } from './User.styles';
import { useUserPage } from './useUserPage';

const maxItemsInContainer = 10;

function User(props) {
  const { params } = props;
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    isRelationPanel,
    isCurrentUser,
    subscriptionRelation,
    posts,
    reviewedUser,
    footerRef,
    reviewedUserSubscriptions,
    reviewedUserSubscribers,
    communities,
    permissions,
    userLoading,
    onSubscribe,
    onUnsubscribe,
  } = useUserPage(params.userId);

  return (
    <PageContainer backButton={true} title={t('user.user')}>
      <div className={classes.userInfoWrapper}>
        <div className={classes.avatar}>
          <AppEntityAvatar
            entity={reviewedUser}
            size={AvatarSize.xl}
            type={AvatarTypes.square}
          />
        </div>
        <div className={classes.userDetails}>
          <div className={classes.info}>
            <Typography variant="text-lg">{`${reviewedUser?.firstname || ''} ${reviewedUser?.lastname || ''}`}</Typography>
            <Typography variant="text-md">
              {reviewedUser?.description}
            </Typography>
          </div>
          {!isCurrentUser && (
            <div className={classes.actions}>
              {!subscriptionRelation && (
                <AppButton onClick={() => onSubscribe()}>
                  {t('user.subscribe')}
                </AppButton>
              )}
              {subscriptionRelation && (
                <AppButton variant="outlined" onClick={() => onUnsubscribe()}>
                  {t('user.unsubscribe')}
                </AppButton>
              )}
              {/*<AppButton onClick={() => onSendMessageClick()}>*/}
              {/*  {t('user.sendMessage')}*/}
              {/*</AppButton>*/}
            </div>
          )}
        </div>
      </div>
      {!userLoading && !permissions.includes('view') && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          marginY={3}>
          <Typography variant="h2">
            {t('user.privatePageMessage').split('.')[0]}
          </Typography>
          <Typography variant="h2">
            {t('user.privatePageMessage').split('.')[1]}
          </Typography>
        </Box>
      )}
      {permissions.includes('view') && (
        <Grid
          container
          spacing={isRelationPanel ? 1 : 0}
          className={clsx(classes.userDetailsWrapper)}>
          <Grid item xs={12} md={isRelationPanel ? 8 : 12}>
            <Posts
              posts={posts}
              newPostBinding={{ pageUserId: reviewedUser?.id }}
              allowNewPost={permissions.includes('post')}
              allowComment={permissions.includes('comment')}
            />
            <Box ref={footerRef} mb={1} />
          </Grid>
          {!!isRelationPanel && (
            <Grid item xs={12} md={4} className={classes.userRelationsWrapper}>
              {!!reviewedUserSubscriptions?.length && (
                <div className={classes.userRelationsContainer}>
                  <Link
                    className={classes.userRelationsHeader}
                    to={`${Paths.users.root}/${reviewedUser?.id}${Paths.users.subscriptions}`}>
                    <div className={classes.userRelationsTitle}>
                      {t('user.userSubscriptions')}
                    </div>
                    <div className={classes.userRelationsCounter}>
                      {reviewedUserSubscriptions.length}
                    </div>
                  </Link>
                  <UsersList
                    users={reviewedUserSubscriptions?.slice(
                      0,
                      maxItemsInContainer,
                    )}
                    type="small"
                  />
                </div>
              )}
              {!!reviewedUserSubscribers?.length && (
                <div className={classes.userRelationsContainer}>
                  <Link
                    className={classes.userRelationsHeader}
                    to={`${Paths.users.root}/${reviewedUser.id}${Paths.users.subscribers}`}>
                    <div className={classes.userRelationsTitle}>
                      {t('user.userSubscribers')}
                    </div>
                    <div className={classes.userRelationsCounter}>
                      {reviewedUserSubscribers.length}
                    </div>
                  </Link>
                  <UsersList
                    users={reviewedUserSubscribers?.slice(
                      0,
                      maxItemsInContainer,
                    )}
                    type="small"
                  />
                </div>
              )}
              {!!communities?.length && (
                <div className={classes.userRelationsContainer}>
                  <Link
                    className={classes.userRelationsHeader}
                    to={`${Paths.users.root}/${reviewedUser.id}${Paths.users.communities}`}>
                    <div className={classes.userRelationsTitle}>
                      {t('home.myCommunities')}
                    </div>
                    <div className={classes.userRelationsCounter}>
                      {communities.length}
                    </div>
                  </Link>
                  <CommunitiesList
                    communities={communities?.slice(0, maxItemsInContainer)}
                    type={CommunityViewType.small}
                  />
                </div>
              )}
            </Grid>
          )}
        </Grid>
      )}
    </PageContainer>
  );
}

export default withRouter(User);
